import axios from 'axios';
import qs from 'qs';
import { Toast } from 'vant';
import i18n from '@/language';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

function readBody(payload) {
  if (payload == null) return null;
  if (typeof payload === 'string') {
    try {
      return JSON.parse(payload);
    } catch (error) {
      return { msg: payload };
    }
  }
  return payload;
}

function isAlreadyActivatedPayload(payload) {
  const body = readBody(payload);
  const msg = body && (body.msg || body.message);
  return String(msg || '').toUpperCase().includes('ALREADY ACTIVATED');
}

function isNoTrialPayload(payload) {
  const body = readBody(payload);
  const msg = body && (body.msg || body.message);
  return String(msg || '').includes('暂无体验套餐');
}

function t(key, fallback) {
  const text = i18n.t(key);
  return text === key ? fallback : text;
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 处理特殊参数格式
    if (config.method === 'post' && config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    if (config.data && config.method !== 'get') {
      if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(config.data);
      } else if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
      }
    }
    // 判断是否需要token（默认需要，除非显式设置needToken: false）
    const needToken = config.needToken !== false;
    if (needToken) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['X-Access-Token'] = `${token}`;
      } else {
        // 未授权处理
        
      }
    }
    return config;
  },
  error => {
    console.error('请求拦截器错误:', error);
    Toast.fail(t('common.requestProcessFail', 'Request processing failed'));
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 200 || res.success) {
      return res;
    } else {
      if (res.code === 400) {
        localStorage.removeItem('token');
        window.location.href = `${process.env.VUE_APP_WEB_URL}/home`;
      } else if (res.code == 500 || isAlreadyActivatedPayload(res)) {
        return res;
      }

      Toast.fail(res.msg || t('common.requestFail', 'Request failed'));
      return Promise.reject(new Error(res.msg || 'Error'));
    }
  },
  error => {
    const data = error.response && error.response.data;
    if (isAlreadyActivatedPayload(data) || isNoTrialPayload(data)) {
      return Promise.resolve(readBody(data));
    }

    console.error('响应拦截器错误:', error);

    let message = t('common.networkError', 'Network request failed, please try again later');
    if (error.response) {
      switch (error.response.status) {
        case 404: message = t('common.notFound', 'Request address not found'); break;
        case 500: message = t('common.serverError', 'Internal server error'); break;
      }
    }

    Toast.fail(message);
    return Promise.reject(error);
  }
);

export default service;
